import { mapGetters, mapActions } from 'vuex';
import mvtDropdownList from '@/common/components/mvtdropdownlist/mvt-dropdownlist.vue';

const schoolCategory = ['elementarySchool', 'middleSchool', 'highSchool'];

export default {
    name: 'searchSchool',
    components: {
        mvtDropdownList,
    },
    data(){
        return {
            openMenu: false,
            selectedSchoolDistrict: null,
            showAllSchools: false,
            selectedSchoolType: 'elementarySchool',
            activeTab: 'public',
            loadingSchools: false,
            privateSchoolsFetched: false,
        }
    },
    computed: {
        ...mapGetters('glb', ['glb']),
        ...mapGetters('msp', ['msp', 'getSchoolsDistrict', 'getPrivateSchools', 'getPublicSchools', 'getGeoDisplayText']),
        allSchools(){
            return Object.values(this.currentSchools).flat();
        },
        currentSchools() {
            const schoolsMap = {
                public: this.getPublicSchools,
                private: this.getPrivateSchools,
            }
            return schoolsMap[this.activeTab] || {};
        },
        schoolDistrictDescription() {
            const name = this.isPublic ? this.selectedSchoolDistrict?.name : this.msp.geo?.formatAddress;
            let description = `${name} has `;
            if(this.schoolsCount.highSchool) description += `${this.schoolsCount.highSchool} high schools, `;
            if(this.schoolsCount.middleSchool) description += `${this.schoolsCount.middleSchool} middle schools, `;
            if(this.schoolsCount.elementarySchool) description += `and ${this.schoolsCount.elementarySchool} elementary schools.`

            if(this.getSchoolsRating) description += ` It has an overall average GreatSchools rating of ${this.getSchoolsRating}/10.`;
            return description;
        },
        getSchoolsRating(){
            const schoolsWithRating = this.allSchools.filter(school => {
                const rating = school.rating;
                return typeof rating === "number" && Number.isFinite(rating) && rating > 0;
            });

            if(!schoolsWithRating.length) return null;
            const total = schoolsWithRating.reduce(( sum, school ) => sum + school.rating, 0);
            return Math.ceil(total / schoolsWithRating.length);
        },
        schools() {
            const { elementarySchool, middleSchool, highSchool } = this.currentSchools || {};
            const all = { elementarySchool, middleSchool, highSchool };
            const list = all[this.selectedSchoolType] || [];
            return list.filter(school => school.type === this.activeTab);
        },
        visibleSchools() {
            return this.showAllSchools ? this.schools : this.schools.slice(0,6);
        },
        schoolType() {
            return [
                {type: 'public', text: 'Public schools'},
                {type: 'private', text: 'Private schools'}
            ]
        },
        isPublic(){
            return this.activeTab === 'public';
        },
        schoolsCount() {
            const { elementarySchool = [], middleSchool = [], highSchool = [] } = this.currentSchools;
            return {
                elementarySchool: elementarySchool.length,
                middleSchool: middleSchool.length,
                highSchool: highSchool.length,
            }
        }
    },
    methods: {
        ...mapActions('msp', ['getSchoolsByDistrict', 'getSchoolsByType']),
        toggleMenu() {
            this.openMenu = !this.openMenu;
        },
        changeSchoolDistrict(id){
            if(id != this.selectedSchoolDistrict.ncesId) {
                this.loadingSchools = true;
                this.getSchoolsByDistrict({ncesId: id}).finally(() => {
                    this.loadingSchools = false;
                });
            }
            this.selectedSchoolDistrict = this.getSchoolsDistrict.find(item => item.ncesId === id);
            this.openMenu = false;
        },
        toggleSchools() {
            this.showAllSchools = !this.showAllSchools;
        },
        switchSchoolCategory(index) {
            this.selectedSchoolType = schoolCategory[index] || 'elementarySchool';
        },
        isActiveTab(tab) {
            return this.activeTab === tab;
        },
        switchSchoolType(tabName) {
            this.activeTab = tabName;
            const payload = {
                type: tabName,
                searchType: this.msp.searchType,
                geoId: this.msp.geo.geoId
            }
            if(tabName === 'private') {
                if(!this.privateSchoolsFetched) {
                    this.loadingSchools = true;
                    this.getSchoolsByType(payload).finally(() =>{
                        this.loadingSchools = false;
                        this.privateSchoolsFetched = true;
                    });
                }
            }
        },
        mspSchoolUrl(item) {
            const cityState = item.dspUrl.split('/')[1];
            const url = `${cityState}/saz-${item.uId}/`;
            return url.toLowerCase();
        }
    },
    watch: {
        getSchoolsDistrict: {
            immediate: true,
            handler(districts) {
                if(districts?.length) {
                    this.selectedSchoolDistrict = districts[0];
                }
            }
        },
    }
};